module.exports = __webpack_public_path__ + "img/deakin.eb50d2c.png";